import type { Product } from 'reactApp/types/Billing';
import { getFirstSomePeriodsAsWord, getPeriodName, isYearPeriod } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

export const getTrialDescription = (product: Product): string => {
    if (!product || !product.hasTrial) {
        return '';
    }

    const { hasDiscount, trialPeriod, discountPeriodCount, discountPeriod } = product;

    const trialPeriodName = trialPeriod && getPeriodName(trialPeriod, false, false, true).replace('\u00A0', '');

    if (hasDiscount && trialPeriodName && discountPeriod) {
        const discountPeriodName = getFirstSomePeriodsAsWord(discountPeriodCount || 1, isYearPeriod(discountPeriod) ? 'y' : 'm');

        return `+${product.space.space} ${product.space.units} на ${trialPeriodName} бесплатно, далее ${formatPrice(
            product.discountPrice
        )} ₽ в ${discountPeriodName}`;
    }

    if (trialPeriodName) {
        return `+${product.space.space} ${product.space.units} на ${trialPeriodName} бесплатно, далее ${formatPrice(
            product.price
        )} ₽ в ${getPeriodName(product.period)}`;
    }

    return '';
};
